import React from "react";
import Image from "next/image";
import { usernameEdit } from "@shared/functions";

interface VideoAvatarProps {
  username: string;
  thumbnail: string;
}

export const VideoAvatar = ({ username, thumbnail }: VideoAvatarProps) => {
  return (
    <div className="flex items-center h-[2.75rem] pl-[0.25rem] pr-3 rounded-full cursor-pointer bg-black/50">
      <div
        className="mr-2 overflow-hidden border-2 rounded-full w-9 h-9 border-primary-color ring-2 ring-primary-color"
        style={{ boxShadow: "1px 1px 30px #00F3CD" }}
      >
        <Image
          src={
            thumbnail ||
            "https://avatars.mds.yandex.net/i?id=2aab3da7d6d7094ebddd1fbbb16277a0_l-5089039-images-thumbs&ref=rim&n=13&w=1080&h=1350"
          }
          className={"object-cover object-center w-full h-full"}
          style={{ maxHeight: "100%", maxWidth: "100%" }}
          width={32}
          height={32}
          alt={""}
          quality={80}
        />
      </div>
      <h3 className="text-[11px] font-normal text-white">
        {usernameEdit(username!)}
      </h3>
    </div>
  );
};
